import { MaxbrainImage } from 'app/library/image-library/models/maxbrain-image.model';
import { ICourseCatalogLandingPageContentQuery } from '../interfaces/course-catalog-landing-page-content.query.interface';
import { CourseCatalogLandingPageCategorySection } from './course-catalog-landing-page-category-section.model';

// @dynamic
export class CourseCatalogLandingPageContent {
    id: string;
    category: CourseCatalogLandingPageCategorySection;
    title: string;
    description: string;
    image: MaxbrainImage;

    constructor(query: ICourseCatalogLandingPageContentQuery) {
        this.id = query.id.toString();
        this.category = new CourseCatalogLandingPageCategorySection(query.category);
        this.title = query.title;
        this.description = query.description;
        this.image = query.image ? new MaxbrainImage(query.image) : null;
    }
}
